module.exports = __webpack_public_path__ + "img/icon-land.42a80ec6.svg";